// An email validator that complies as closely as possible with Django's EmailValidator.
// The only difference is that this does not allow ipv4, ipv6, or localhost.
// Control characters are intentional here (RFC 5321 qtext), not a mistake.
const USER_REGEX =
  // eslint-disable-next-line no-control-regex
  /(^[-!#$%&'*+/=?^_`{}|~0-9A-Z]+(\.[-!#$%&'*+/=?^_`{}|~0-9A-Z]+)*$|^"([\x01-\x08\x0b\x0c\x0e-\x1f!#-[\]-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*"$)/i;
const DOMAIN_REGEX =
  /^(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+[A-Z0-9](?:[A-Z0-9-]{0,60}[A-Z0-9])$/i;

/**
 * Checks if a value is an email address
 * @param value - The value to check
 * @returns true if email false otherwise
 */
export const isEmail = (value: string): boolean => {
  return value.includes("@");
};

export const isEmailValid = (email) => {
  if (email.includes(" ")) {
    return false;
  }

  const lastAtIndex = email.lastIndexOf("@");

  if (lastAtIndex === -1) {
    return false;
  }

  const userPart = email.slice(0, lastAtIndex);

  if (!USER_REGEX.test(userPart)) {
    return false;
  }

  const domainPart = email.slice(lastAtIndex + 1);

  return DOMAIN_REGEX.test(domainPart);
};
